import { create } from 'zustand';

// Estado del sidebar (colapsado / expandido).
// Persiste la preferencia en localStorage para que el usuario no tenga que
// volver a colapsar en cada reload.

export interface SidebarState {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (c: boolean) => void;
}

// Clave de localStorage usada por el sidebar.
const STORAGE_KEY = 'cef:sidebar';

// Lee el estado persistido. Si está bloqueado o no es válido, devuelve `false`.
function readStoredCollapsed(): boolean {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === '1') return true;
    if (stored === '0') return false;
  } catch {
    // localStorage bloqueado (modo privado / SSR / sandbox).
  }
  return false;
}

// Persiste el estado. Silencia errores de localStorage bloqueado.
function writeStoredCollapsed(collapsed: boolean): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
  } catch {
    // localStorage bloqueado: el store sigue funcionando en memoria.
  }
}

const initialCollapsed: boolean =
  typeof window === 'undefined' ? false : readStoredCollapsed();

export const useSidebarStore = create<SidebarState>((set, get) => ({
  collapsed: initialCollapsed,
  toggle: () => {
    const next = !get().collapsed;
    writeStoredCollapsed(next);
    set({ collapsed: next });
  },
  setCollapsed: (c) => {
    writeStoredCollapsed(c);
    set({ collapsed: c });
  },
}));
